export const holidays = [
  {
    name: "New Year Day",
    date: "2026-01-01",
  },
  {
    name: "Makara Sankranti",
    date: "2026-01-14",
  },
  {
    name: "Republic Day",
    date: "2026-01-26",
  },
  {
    name: "Holi",
    date: "2026-03-04",
  },
  {
    name: "Ugadi",
    date: "2026-03-19",
  },
  {
    name: "Sri Rama Navami",
    date: "2026-03-26",
  },
  {
    name: "Bakrid",
    date: "2026-05-28",
  },
  {
    name: "Raksha Bandhan",
    date: "2026-08-28",
  },
  {
    name: "Ganesh Chaturthi",
    date: "2026-09-14",
  },
  {
    name: "Vijayadashami",
    date: "2026-10-20",
  },
  {
    name: "Deepavali",
    date: "2026-11-10",
  },
  {
    name: "Christmas",
    date: "2026-12-25",
  },
];